(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-gift-assistant"] && !Shopify.designMode) return;
  try {
    (function(){
  var fab = document.getElementById('vt-ai-fab');
  var root = document.getElementById('vt-ai-root');
  var backdrop = document.getElementById('vt-ai-backdrop');
  var closeBtn = document.getElementById('vt-ai-close');
  if(!fab || !root) return;

  var answers = {};
  var currentStep = 1;
  var TOTAL_STEPS = 5;

  function openAssistant(){ root.hidden = false; }
  function closeAssistant(){ root.hidden = true; }
  fab.addEventListener('click', openAssistant);
  closeBtn.addEventListener('click', closeAssistant);
  backdrop.addEventListener('click', closeAssistant);

  function showStep(n){
    document.querySelectorAll('[data-vt-step]').forEach(function(el){
      el.hidden = el.getAttribute('data-vt-step') !== String(n);
    });
    document.querySelectorAll('#vt-ai-progress span').forEach(function(dot, i){
      dot.classList.toggle('is-active', (i + 1) <= (typeof n === 'number' ? n : TOTAL_STEPS));
    });
    document.getElementById('vt-ai-progress').hidden = (n === 'results');
  }

  document.querySelectorAll('.vt-ai__options').forEach(function(group){
    group.addEventListener('click', function(e){
      var btn = e.target.closest('button');
      if(!btn) return;
      var question = group.getAttribute('data-vt-question');
      answers[question] = btn.dataset.value;
      if(currentStep < TOTAL_STEPS){
        currentStep++;
        showStep(currentStep);
      } else {
        showStep('results');
        runSearch();
      }
    });
  });

  document.getElementById('vt-ai-restart').addEventListener('click', function(){
    answers = {};
    currentStep = 1;
    showStep(1);
  });

  // ---- Real-taxonomy mapping (matches actual Shopify tags used in this store) ----
  var RECIPIENT_TAGS = { her: 'recipient-her', him: 'recipient-him', kids: 'recipient-kids', couple: 'recipient-couple', friend: 'recipient-friend', teacher: 'recipient-teacher' };
  var OCCASION_TAGS = { birthday: 'occasion-birthday', anniversary: 'occasion-anniversary', graduation: 'occasion-graduation', wedding: 'occasion-wedding', 'new-baby': 'occasion-new-baby', corporate: 'occasion-corporate' };
  var STYLE_TAGS = { cute: 'style-cute', elegant: 'style-elegant', practical: 'style-practical', luxury: 'status-premium', personalized: 'customizable', romantic: 'style-romantic' };

  // ==========================================================================
  // PHASE 2 SWAP POINT: replace the body of getRecommendations() with a
  // fetch() to a secure backend endpoint that itself calls an AI provider.
  // The backend holds the API key; this file never will. The function
  // signature and return shape (a Promise resolving to an array of Shopify
  // product objects) stay the same either way, so nothing else in this file
  // needs to change.
  // ==========================================================================
  function getRecommendations(ans){
    if(ans.format === 'ready'){
      return Promise.resolve({ redirect: window.Shopify ? '/pages/ready-gifts' : '/pages/ready-gifts' });
    }
    if(ans.format === 'build'){
      return Promise.resolve({ redirect: '/pages/build-your-own-gift-box-1' });
    }
    return fetch('/products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = data.products || [];
        var maxPriceCents = parseInt(ans.budget, 10) * 100;
        var wantedTags = [];
        if(RECIPIENT_TAGS[ans.recipient]) wantedTags.push(RECIPIENT_TAGS[ans.recipient]);
        if(OCCASION_TAGS[ans.occasion]) wantedTags.push(OCCASION_TAGS[ans.occasion]);
        if(STYLE_TAGS[ans.style]) wantedTags.push(STYLE_TAGS[ans.style]);

        function matchScore(product){
          var tags = (product.tags || []).map(function(t){ return t.toLowerCase(); });
          var score = 0;
          wantedTags.forEach(function(t){ if(tags.indexOf(t) > -1) score++; });
          return score;
        }
        function cheapestVariantCents(product){
          var prices = (product.variants || []).map(function(v){ return Math.round(parseFloat(v.price) * 100); });
          return prices.length ? Math.min.apply(null, prices) : Infinity;
        }
        function inStock(product){
          return (product.variants || []).some(function(v){ return v.available !== false; });
        }

        var scored = products
          .filter(function(p){ return cheapestVariantCents(p) <= maxPriceCents; })
          .filter(inStock)
          .map(function(p){ return { product: p, score: matchScore(p), priceCents: cheapestVariantCents(p) }; })
          .filter(function(x){ return x.score > 0; })
          .sort(function(a, b){ return b.score - a.score || a.priceCents - b.priceCents; });

        return { items: scored.slice(0, 6) };
      });
  }

  function formatPrice(cents){
    return '$' + (cents / 100).toFixed(2);
  }

  function whyItMatches(ans){
    var parts = [];
    if(ans.recipient) parts.push('for ' + ans.recipient);
    if(ans.occasion) parts.push(ans.occasion.replace('-', ' '));
    if(ans.style) parts.push(ans.style + ' style');
    return 'Matches ' + parts.join(', ');
  }

  function runSearch(){
    var loading = document.getElementById('vt-ai-loading');
    var grid = document.getElementById('vt-ai-grid');
    var empty = document.getElementById('vt-ai-empty');
    var emptySuggestion = document.getElementById('vt-ai-empty-suggestion');
    var heading = document.getElementById('vt-ai-results-heading');

    loading.hidden = false;
    grid.innerHTML = '';
    empty.hidden = true;

    getRecommendations(answers).then(function(result){
      loading.hidden = true;

      if(result.redirect){
        window.location.href = result.redirect;
        return;
      }

      var items = result.items || [];
      if(items.length === 0){
        heading.textContent = "We couldn't find an exact match";
        empty.hidden = false;
        emptySuggestion.textContent = 'Try browsing our full Shop page, or message us directly — we\'ll help you find something in person.';
        return;
      }

      heading.textContent = items.length + ' gift' + (items.length === 1 ? '' : 's') + ' we think they\'ll love';
      items.forEach(function(entry){
        var p = entry.product;
        var img = p.images && p.images[0] ? p.images[0].src : '';
        var variant = p.variants && p.variants[0];
        var priceCents = variant ? Math.round(parseFloat(variant.price) * 100) : 0;
        var card = document.createElement('div');
        card.className = 'vt-ai__card';
        card.innerHTML =
          (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g,'&quot;') + '" loading="lazy">' : '') +
          '<p class="vt-ai__card-title">' + p.title + '</p>' +
          '<p class="vt-ai__card-price">' + formatPrice(priceCents) + '</p>' +
          '<p class="vt-ai__card-why">' + whyItMatches(answers) + '</p>' +
          '<div class="vt-ai__card-actions">' +
            '<a class="vt-ai__view" href="/products/' + p.handle + '">View Product</a>' +
            (variant ? '<button type="button" class="vt-ai__add" data-variant-id="' + variant.id + '">Add to Cart</button>' : '') +
          '</div>';
        grid.appendChild(card);
      });

      grid.querySelectorAll('.vt-ai__add').forEach(function(btn){
        btn.addEventListener('click', function(){
          btn.disabled = true; btn.textContent = 'Adding\u2026';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
          }).then(function(r){ return r.json(); }).then(function(){
            btn.textContent = 'Added \u2713';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }).catch(function(){
            btn.disabled = false; btn.textContent = 'Add to Cart';
          });
        });
      });
    }).catch(function(){
      loading.hidden = true;
      empty.hidden = false;
      emptySuggestion.textContent = 'Something went wrong searching our catalog — please try WhatsApp instead.';
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
